import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-159a9c94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "commentCart" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "action" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "action" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }

import { IconMessage } from "@arco-design/web-vue/es/icon";
import API from "@/api";
import { ref, watchEffect } from "vue";
import { useLoginUserStore } from "@/store/userStore";
import {
  addCommentUsingPost,
  deleteCommentUsingPost,
  doCommentThumbUsingPost,
  getCommentVoByTargetIdUsingPost,
} from "@/request/api/commentController";
import dayjs from "dayjs";
import message from "@arco-design/web-vue/es/message";

interface Props {
  bizId: number;
  bizType: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CommentCart',
  props: {
    bizId: { default: () => {
    return 0;
  } },
    bizType: { default: () => {
    return "";
  } }
  },
  setup(__props: any) {

const props = __props;

//查询登录用户
const loginUser = ref<API.UserVO>(useLoginUserStore().loginUser);
const userAvatar = ref<string>(
  loginUser.value.userAvatar == null
    ? "https://p1-arco.byteimg.com/tos-cn-i-uwbnlip3yd/9eeb1800d9b78349b24682c3518ac4a3.png~tplv-uwbnlip3yd-webp.webp"
    : loginUser.value.userAvatar
);

const dataList = ref<API.CommentVO[]>([]);

//查询参数
const searchParams = ref<API.InterviewQuestionBankQueryRequest>({
  current: 1,
  pageSize: 20,
});

// 评论内容
const commentText = ref<string>();
// 回复内容
const replyText = ref<string>();
// 评论加载中
const commentLoading = ref(false);

/**
 * 加载评论
 */
const loadComment = async () => {
  if (props.bizId == 0 || props.bizType == "") {
    return;
  }
  commentLoading.value = true;
  const response = await getCommentVoByTargetIdUsingPost({
    bizId: props.bizId,
    bizType: props.bizType,
  });
  if (response.data.code === 0 && response.data.data) {
    dataList.value = response.data.data;
  } else {
    dataList.value = [];
  }
  commentLoading.value = false;
};

/**
 * 监听 searchParams 变量，改变时触发数据的重新加载
 */
watchEffect(() => {
  loadComment();
});

/**
 * 格式化日期时间
 */
const formatDateTime = (dateTime: any) => {
  if (dateTime == null) {
    return "";
  }
  const format = dayjs(dateTime).format("YYYY-MM-DD HH:mm:ss");
  return format;
};
/**
 * 取消评论
 */
const cancel = () => {
  commentText.value = "";
};

/**
 * 取消评论
 */
const remove = async (id: number) => {
  const response = await deleteCommentUsingPost({ id: id });
  if (response.data.code === 0) {
    message.success("删除成功");
    loadComment();
  } else {
    message.error("删除失败，" + response.data.message);
  }
};

/**
 * 点赞
 */
const like = (item: any) => {
  if (item.isThumb) {
    item.thumbNum--;
  } else {
    item.thumbNum++;
    message.success("点赞成功");
  }
  item.isThumb = !item.isThumb;
  doCommentThumbUsingPost({ bizId: item.id, bizType: "Comment" });
};
/**
 * 回复
 * @param id
 * @param userId
 */
const replyL2 = async (data: any, item: any) => {
  if (replyText.value == null || replyText.value == "") {
    return;
  }
  const response = await addCommentUsingPost({
    bizId: props.bizId,
    bizType: props.bizType,
    pid: item.id,
    toUserId: data.userId,
    content: replyText.value,
  });
  if (response.data.code === 0) {
    message.success("评论成功");
    replyText.value = "";
    loadComment();
  } else {
    message.error("评论失败，" + response.data.message);
  }
};
/**
 * 回复
 */
const replyL1 = async (item: any) => {
  if (replyText.value == null || replyText.value == "") {
    return;
  }
  const response = await addCommentUsingPost({
    bizId: props.bizId,
    bizType: props.bizType,
    pid: item.id,
    content: replyText.value,
  });
  if (response.data.code === 0) {
    message.success("评论成功");
    replyText.value = "";
    loadComment();
  } else {
    message.error("评论失败，" + response.data.message);
  }
};

/**
 * 进行评论
 */
const comment = async () => {
  if (commentText.value == null || commentText.value == "") {
    return;
  }
  const response = await addCommentUsingPost({
    bizId: props.bizId,
    bizType: props.bizType,
    content: commentText.value,
    pid: 0,
  });
  if (response.data.code === 0) {
    message.success("评论成功");
    commentText.value = "";
    loadComment();
  } else {
    message.error("评论失败，" + response.data.message);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_comment = _resolveComponent("a-comment")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_IconHeartFill = _resolveComponent("IconHeartFill")!
  const _component_IconHeart = _resolveComponent("IconHeart")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_icon_delete = _resolveComponent("icon-delete")!
  const _component_icon_arrow_right = _resolveComponent("icon-arrow-right")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_comment, {
      align: "right",
      avatar: userAvatar.value
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "secondary",
          onClick: cancel
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 取消")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: comment
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 回复")
          ]),
          _: 1
        })
      ]),
      content: _withCtx(() => [
        _createVNode(_component_a_input, {
          modelValue: commentText.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((commentText).value = $event)),
          placeholder: "有什么想说的..."
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["avatar"]),
    _createVNode(_component_a_divider),
    _createVNode(_component_a_spin, {
      loading: commentLoading.value,
      tip: "评论正在加载",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_list, {
          class: "list-demo-action-layout",
          bordered: false,
          data: dataList.value
        }, {
          item: _withCtx(({ item }) => [
            _createVNode(_component_a_list_item, {
              class: "list-item",
              "action-layout": "vertical"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_comment, {
                  author: item.userName,
                  avatar: item.userAvatar,
                  content: item.content,
                  datetime: formatDateTime(item.createTime)
                }, {
                  actions: _withCtx(() => [
                    _createElementVNode("span", {
                      class: "action",
                      onClick: ($event: any) => (like(item))
                    }, [
                      (item.isThumb)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                            _createVNode(_component_IconHeartFill, { style: { color: '#f53f3f' } })
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_4, [
                            _createVNode(_component_IconHeart)
                          ])),
                      _createTextVNode(" " + _toDisplayString(item.thumbNum), 1)
                    ], 8, _hoisted_2),
                    _createVNode(_component_a_popover, {
                      title: '回复：@' + item.userName,
                      trigger: "click",
                      position: "rt",
                      style: {"width":"500px"},
                      onPopupVisibleChange: _cache[2] || (_cache[2] = ($event: any) => (replyText.value = ''))
                    }, {
                      content: _withCtx(() => [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              modelValue: replyText.value,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((replyText).value = $event)),
                              placeholder: "有什么想说的...",
                              style: {"width":"400px"},
                              "allow-clear": ""
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_a_button, {
                              type: "primary",
                              onClick: ($event: any) => (replyL1(item))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 回复 ")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_5, [
                          _createVNode(_unref(IconMessage)),
                          _createTextVNode(" 回复 ")
                        ])
                      ]),
                      _: 2
                    }, 1032, ["title"]),
                    (item.isMy)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "action",
                          onClick: ($event: any) => (remove(item.id))
                        }, [
                          _createVNode(_component_icon_delete)
                        ], 8, _hoisted_6))
                      : _createCommentVNode("", true)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.replies, (data) => {
                      return (_openBlock(), _createBlock(_component_a_comment, {
                        avatar: data.userAvatar,
                        content: data.content,
                        datetime: formatDateTime(data.createTime),
                        key: data.id
                      }, {
                        actions: _withCtx(() => [
                          _createElementVNode("span", {
                            class: "action",
                            onClick: ($event: any) => (like(data))
                          }, [
                            (data.isThumb)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                  _createVNode(_component_IconHeartFill, { style: { color: '#f53f3f' } })
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                  _createVNode(_component_IconHeart)
                                ])),
                            _createTextVNode(" " + _toDisplayString(data.thumbNum), 1)
                          ], 8, _hoisted_7),
                          _createVNode(_component_a_popover, {
                            title: '回复：@' + item.userName,
                            trigger: "click",
                            position: "rt",
                            style: {"width":"500px"}
                          }, {
                            content: _withCtx(() => [
                              _createVNode(_component_a_space, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    modelValue: replyText.value,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((replyText).value = $event)),
                                    placeholder: "有什么想说的...",
                                    style: {"width":"400px"}
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_a_button, {
                                    type: "primary",
                                    onClick: ($event: any) => (replyL2(data, item))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" 回复 ")
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_10, [
                                _createVNode(_unref(IconMessage)),
                                _createTextVNode(" 回复 ")
                              ])
                            ]),
                            _: 2
                          }, 1032, ["title"]),
                          (data.isMy)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "action",
                                onClick: ($event: any) => (remove(data.id))
                              }, [
                                _createVNode(_component_icon_delete)
                              ], 8, _hoisted_11))
                            : _createCommentVNode("", true)
                        ]),
                        author: _withCtx(() => [
                          (data.toUserName == null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(data.userName), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                _createTextVNode(_toDisplayString(data.userName) + " ", 1),
                                _createVNode(_component_icon_arrow_right),
                                _createTextVNode(" " + _toDisplayString(data.toUserName), 1)
                              ]))
                        ]),
                        _: 2
                      }, 1032, ["avatar", "content", "datetime"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["author", "avatar", "content", "datetime"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["loading"])
  ]))
}
}

})